"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const MuiDrawerOverrides = {
    MuiDrawer: {
        styleOverrides: {},
    },
};
exports.default = MuiDrawerOverrides;
//# sourceMappingURL=muiDrawerOverride.js.map